"use strict";

exports.__esModule = true;
exports.default = void 0;

var _img = _interopRequireDefault(require("./img"));

var _imgLazy = _interopRequireDefault(require("./img-lazy"));

var _plugins = require("../../utils/plugins");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = {
  BImg: _img.default,
  BImgLazy: _imgLazy.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    components: components
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/image/index.js
// module id = 223
// module chunks = 43